import {RemoteData} from "../timing_lite/store";

export function isEmpty(value: any): boolean {
    return value === undefined || value === null || value === ""
}

export let logger: (message?: any, ...optionalParams: any[]) => void;

const REMOTE_DATA: RemoteData = window.json_context;


if (REMOTE_DATA.debug) {
    logger = console.log;
} else {
    logger = function (message?: any, ...optionalParams: any[]) {

    }
}


export interface Map<K, V> {
    [K: string]: V;
}

// interface MapConstructor {
//     // fromJSON(json: string): Map<any, any>;
//     // fromJSON<K, V>(json: string): Map<K, V>;
//
// }


interface Option {
    name: string,
    value: any
}

export const generateFile = function (url: string, data: any, dataType: string, fileName: string, options: Option[] = []) {
    const form = document.createElement('form') as HTMLFormElement
    document.querySelector('body')!.appendChild(form)

    form.setAttribute("method", "post");
    form.setAttribute("action", url);

    const all_options: Option[] = [
        {name: 'filename', value: fileName},
        {name: 'data_type', value: dataType},
        {name: 'data', value: data},
        ...options
    ]

    for (let option of all_options) {
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", option.name);
        input.setAttribute("value", option.value);
        form.appendChild(input)
    }
    form.submit()
    form.remove()
};
